import { Injectable, signal } from '@angular/core';
import notify from 'devextreme/ui/notify';

declare function require(moduleName: string): any;
export const { version: appVersion } = require('../../../package.json');

@Injectable({ providedIn: 'root' })
export class AppInfoService {
  appVersion: string = appVersion;
  isLoading = signal(false);

  public get title() {
    return 'MSHN Forms';
  }

  public get currentYear() {
    return new Date().getFullYear();
  }

  notify(message: string, type: 'info' | 'warning' | 'error' | 'success' = 'success', displayTime = 3000) {
    notify(
      { message, type, displayTime, closeOnClick: true, width: '300px' },
      {
        position: 'bottom right',
        direction: 'up-push'
      }
    );
  }
}
